import { createEntity } from 'lib/resource';
import Show from './schema';

export default createEntity(Show);
